import React, { useEffect, useState } from "react";
import axios from "axios";
import EventHero from "../../components/User/EventPackages/EventHero";
import WhyUs from "../../components/User/EventPackages/WhyUs";
import PackageCards from "../../components/User/EventPackages/PackageCards";
import ComparisonGrid from "../../components/User/EventPackages/ComparisonGrid";
import SportsSelection from "../../components/User/EventPackages/SportsSelection";
import AddOnsCustomization from "../../components/User/EventPackages/AddOnsCustomization";
import FoodAndBeverage from "../../components/User/EventPackages/FoodAndBeverage";
import WhatsIncluded from "../../components/User/EventPackages/WhatsIncluded";
import HowItWorks from "../../components/User/EventPackages/HowItWorks";
import EventPolicies from "../../components/User/EventPackages/EventPolicies";
import EventFaqs from "../../components/User/EventPackages/EventFaqs";
import FinalCta from "../../components/User/EventPackages/FinalCta";

const EventPackages = () => {
  const [packagesData, setPackagesData] = useState(null);
  const [addonsData, setAddonsData] = useState([]);
  const [policiesData, setPoliciesData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Fetch dynamic event packages, add-ons, and policies from backend API
    const fetchPackagesContent = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/event-packages/content`,
        );
        if (response?.data?.success) {
          setPackagesData(response.data.packages || []);
          if (response.data.addons?.length > 0) {
            setAddonsData(response.data.addons);
          }
          if (response.data.policies?.length > 0) {
            setPoliciesData(response.data.policies);
          }
        }
      } catch (err) {
        console.log(
          "Error loading dynamic event packages content, using defaults:",
          err,
        );
        setPackagesData([]);
      }
    };

    fetchPackagesContent();
  }, []);

  return (
    <React.Fragment>
      <EventHero />
      <WhyUs />
      {/* 1. CHOOSE YOUR SQUAD PACKAGE */}
      <PackageCards dynamicPackages={packagesData} />
      {/* 2. DETAILED COMPARISON GRID */}
      <ComparisonGrid dynamicPackages={packagesData} />
      {/* 3. CHOOSE YOUR SPORTS */}
      <SportsSelection />
      {/* 4. ADD-ONS & CUSTOMIZATION */}
      <AddOnsCustomization dynamicAddons={addonsData} />
      {/* 5. BUILD YOUR FOOD & BEVERAGE EXPERIENCE */}
      <FoodAndBeverage />
      {/* 6. WHAT'S INCLUDED IN EVERY PACKAGE */}
      <WhatsIncluded />
      {/* 7. HOW IT WORKS */}
      <HowItWorks />
      {/* 8. IMPORTANT NOTICE & POLICY */}
      <EventPolicies dynamicPolicies={policiesData} />
      {/* 9. FREQUENTLY ASKED QUESTIONS */}
      <EventFaqs />
      {/* 10. FINAL CTA */}
      <FinalCta />
    </React.Fragment>
  );
};

export default EventPackages;
